import { fetch } from '../../plugin/axios'

const serverName = '/financial'

/**
 * 获取分成统计数据
 */
export function getShareStatistics() {
  return fetch({
    url: serverName + '/share/result/statistics',
    method: 'GET'
  })
}
